import { getSortAndFilterOption, SortAndFilterDisplayField } from 'stores/adapters/bex-api/search/search-sort-filter-adapter';
import { SearchCriteriaModel } from 'stores/models/search-criteria-model';

import { getMatchingFilterOption } from './filter-utils';

import { ReviewScoreRangeInput } from '__generated__/api';

export const getReviewScoreRangeInput = (searchCriteria: SearchCriteriaModel, sortAndFilterOptions: any): ReviewScoreRangeInput | null => {
  if (searchCriteria && searchCriteria.guestRating) {
    const reviewScoreOptions = getSortAndFilterOption(SortAndFilterDisplayField.GUEST_RATING, sortAndFilterOptions);

    if (reviewScoreOptions) {
      const matchingOption = getMatchingFilterOption(searchCriteria.guestRating, reviewScoreOptions);

      if (matchingOption) {
        let minMatchingOptionValue = matchingOption.range && matchingOption.range.min;
        let maxMatchingOptionValue = matchingOption.range && matchingOption.range.max;

        minMatchingOptionValue =
          !minMatchingOptionValue && matchingOption.value ? parseInt(matchingOption.value, 10) : minMatchingOptionValue;
        maxMatchingOptionValue =
          !maxMatchingOptionValue && matchingOption.value ? parseInt(matchingOption.value, 10) : maxMatchingOptionValue;

        if (minMatchingOptionValue && maxMatchingOptionValue) {
          return {
            min: minMatchingOptionValue,
            max: maxMatchingOptionValue,
          };
        }
      }
    }
  }

  return null;
};
